<template>
    <div class="animated fadeIn container-fluid">

        <b-row>
            <b-col md="6">

                <div v-if="draw_accesspoint">
                    <h3 class="card-title agri-color">
                        <i :class="$tools.style.classIcon(draw_accesspoint.type, 'block-title clickable-md')"></i>
                        <div class="block-text">
                            <div class="block-md">{{ draw_accesspoint.hashid }}</div>
                            <div class="device-show-id">AccessPoint ID = {{ draw_accesspoint.deviceid }}</div>
                            <span v-if="draw_accesspoint.nickname">( {{ draw_accesspoint.nickname }} )</span>
                        </div>
                    </h3>
                    <div class="block-text">
                        <b-alert v-if="draw_accesspoint.note" variant="secondary" show >Note：{{ draw_accesspoint.note }}</b-alert>
                    </div>
                </div>

            </b-col>
            <b-col md="6">

                <div class="text-center">
                    <h5>歷史資料範圍選擇 (非自動更新，10 分鐘一筆)</h5>

                    <DatePickerTool :timezone="timezone"
                                    :no_bounding="true"
                                    :shortcut_no_shift="true"
                                    :default_query="default_dateRange"
                                    @date-range="dateRange = $event"
                    ></DatePickerTool>

                    <!-- Show -->
                    <b-button id="button-show" class="btn btn-success px-4 btn-upload"
                            @click="setQueryRange('history')"
                            :disabled="loading || checkDisabled" >
                        <i class="fa fa-search block-text"></i>{{ $t('menu.show') }}
                    </b-button>
                </div>

            </b-col>
        </b-row>


        <!-- 阿龜資料讀取畫面 -->
        <div v-if="loading">
            <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
        </div>

        <div id="dashboard" v-if="draw_accesspoint && deviceData">

            <TableData :deviceData="deviceData" :deviceType="'accesspoint'" :sensorParams="draw_accesspoint.sensor_params"></TableData>

            <h4 class="header-sub">Echarts 圖表</h4>
            <div v-if="deviceData.time.length > 0">
                <AccessPointChart :id="'device-chart-block-' + draw_accesspoint.hashid"
                            :autoUpdate="false"
                            :importData="deviceData"
                            :importQuery_Range="importQuery_Range"
                            :importQuery_Unit="importQuery_Unit"
                            :importQuery_DataCount="importQuery_DataCount"
                            :device="draw_accesspoint"
                            :info_type="info_type"
                            :showToolbox="true"
                            :project_id="'undefined'"
                            :cropperiod_id="'undefined'"
                            :project_role="'admin'"
                            :sensor_rules="{}"
                            :timezone="timezone"></AccessPointChart>
            </div>
            <div v-else>
                <NoData></NoData>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapState }         from 'vuex'
    import AgriLoading          from '@/views/components/AgriLoading'
    import NoData               from '@/views/components/NoData'
    import AccessPointChart     from '@/views/device/Chart_AccessPoint'
    import NoteFarmWork         from '@/views/project/agriNote/Note_FarmWork'
    import TableData            from '@/views/components/Table_Data'
    import DatePickerTool       from '@/views/components/DatePickerTool'
    import ecTools              from '@/echarts/echarts-tools'

    export default {
        components: {
            AgriLoading,
            NoData,
            AccessPointChart,
            NoteFarmWork,
            TableData,
            DatePickerTool,
        },
        data () {
            return {
                loading: false,
                deviceData: undefined,
                draw_accesspoint: undefined,
                // queryRange: 6,
                timezone: 'Asia/Taipei',
                info_type: 'history', //'realtime',
                default_dateRange: [undefined,undefined],
                dateRange: undefined,

                importQuery_Range: 6,
                importQuery_Unit: '',
                importQuery_DataCount: 6 * 2,
            }
        },
        // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
        beforeRouteUpdate(to, from, next) {
            this.getDetail_byID(to, from, next);

        },
        mounted () {
            this.getDetail_byID();
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'admin_AccessPoint_List': state => state.accesspoint.accesspoints,
            }),

            deviceID() {
                return this.$route.params.deviceID;
            },

            // Download Button Check State
            checkDisabled () {

                if (this.dateRange == undefined)             return true;
                if (this.dateRange.start_time == undefined)  return true;
                if (this.dateRange.end_time == undefined)    return true;

                return false;
            },
        },
        methods: {

            getDateRange (_Day_shift = -6, _End_Day_shift = 0)
            {
                // 取得前 { _Day_shift + 1 } 天日期
                let _date_today = this.$tools.date.getDateNow( this.timezone, 'YYYY-MM-DD 23:59' );
                let _dateNow = this.$tools.date.getDateShift( _date_today, _End_Day_shift, 'days' ); // 取前一天資料
                let _dateStart = this.$tools.date.getDateShift( _dateNow, _Day_shift, 'days', 'YYYY-MM-DD 00:00' );

                this.default_dateRange = [ _dateStart, _dateNow ]
                this.dateRange = {
                    start_time: _dateStart,
                    end_time:   _dateNow,
                }
            },

            setQueryRange (range = 'history')
            {
                // this.queryRange = range;
                if (range != 'history')
                {
                    // this.info_type = 'realtime';
                    // this.getData_Realtime();
                }
                else
                {
                    this.info_type = 'history';
                    this.getData_Records();
                }
            },

            activeQueryRage (range)
            {
                if (this.queryRange == range) return true
                return false
            },

            getData_Records ()
            {
                if (this.deviceID)
                {
                    this.loading = true
                    this.deviceData = undefined

                    let _start_time = this.$tools.date.dataTimeZone_to_UTC( this.dateRange.start_time, this.timezone );
                    let _end_time = this.$tools.date.dataTimeZone_to_UTC( this.dateRange.end_time, this.timezone );

                    let querySettings = {
                        deviceID:       this.deviceID,
                        timezone:       this.timezone,
                        start_time:     _start_time,
                        end_time:       _end_time,
                        url:            this.$config.getAPI_URL('Admin_AccessPoint_Records', { deviceID: this.deviceID, start_time: _start_time, end_time: _end_time }),
                    }
                    this.$store.dispatch('accesspoint/get_Records', querySettings)
                        .then( res => {
                            this.loading = false
                            this.deviceData = res

                            this.importQuery_Range = this.$tools.date.countDays(res.time[0], res.time[ res.time.length-1 ]) + 1;
                            this.importQuery_Unit = this.$t('u.days');
                            this.importQuery_DataCount = this.importQuery_Range * 24 * 2; // Admin 用的 Logs 會回傳 30 分鐘資料

                            this.draw_accesspoint.sensor_params = []
                            let _keys = Object.keys( this.deviceData )
                            _keys.forEach( _key => {

                                if (_key == 'time') {}
                                else
                                {
                                    this.draw_accesspoint.sensor_params.push( _key )
                                }
                            })

                        })
                        .catch( err => {
                            this.loading = false

                        })
                }

            },


            getDetail_byID (to = undefined, from = undefined, next = undefined)
            {
                this.deviceData = undefined;
                let _deviceID = (next ? to.params.deviceID : this.deviceID)

                if (_deviceID)
                {
                    this.loading = true
                    const settings = {
                        deviceID: _deviceID,
                        timezone: this.timezone,
                    }
                    this.$store.dispatch('accesspoint/get_Detail', settings)
                        .then( res => {
                            this.loading = false

                            if ( res.accesspoint )
                            {
                                this.draw_accesspoint = res.accesspoint
                            }

                            // 自動先取得 6+1 天前的資料
                            this.getDateRange()
                            this.setQueryRange()

                            if (next) next();
                        })
                        .catch( err => {
                            this.loading = false
                        })
                }
                else
                {
                    this.router.push({ name:'Page 404' })
                }
            },

        }
    }
</script>

<style lang="scss" scoped>

.device-show-id
{
    display: inline-block;
    font-size: 0.9rem;
    color: green;
    margin-right: 15px;
}

</style>
